import { z } from 'zod';
import { PASSWORD_MIN_LENGTH } from '../constants/index.js';
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .email("L'adresse email est invalide.")
    .max(254);
export const passwordSchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, `Le mot de passe doit contenir au moins ${PASSWORD_MIN_LENGTH} caractères.`)
    .max(128, 'Le mot de passe est trop long.')
    .refine((v) => /[A-Z]/.test(v), 'Au moins une majuscule.')
    .refine((v) => /[a-z]/.test(v), 'Au moins une minuscule.')
    .refine((v) => /[0-9]/.test(v), 'Au moins un chiffre.')
    .refine((v) => /[^A-Za-z0-9]/.test(v), 'Au moins un caractère spécial.');
export const uuidSchema = z.string().uuid("L'identifiant est invalide.");
export const totpCodeSchema = z
    .string()
    .regex(/^\d{6}$/, 'Le code à 6 chiffres est requis.');
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
//# sourceMappingURL=common.js.map